import React, { useEffect, useState } from 'react'
import { CartService } from './Service'
import { Box, Button, IconButton, Modal, Typography } from '@mui/material';
import Loading from '../../../components/Loader/Loading';
import { DataGrid } from '@mui/x-data-grid';
import useResponsive from '../../../hooks/useResponsive';
import NoRowsLayout from '../../../components/Layout/NoRowsLayout';
import { formatDateTime } from '../../../utils/dateUtils';
import { Close } from '@mui/icons-material';
import CartDetails from './CartDetails';
// import ExportAll from './filterAndExport/ExportAll';
import MultiColumnFilter from '../../../components/Filter/MultiColumnFilter';
import ExportAll from './ExportAll';

const AbandonedCartList = () => {
  const { isSm } = useResponsive();
  const [loadingCart, setLoadingCart] = useState(false);

  const [cartList, setCartList] = useState([]);
  const [allRowCount, setAllRowCount] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 50,
    filters: {
      searchKey: "",
      sortBy: 'createdAt',
      sortType: 'desc',
      filterOptions: []
    }
  });
  const handlePaginationChange = (newPagination) => {
    setPaginationModel({
      ...paginationModel,
      page: newPagination.page,
      pageSize: newPagination.pageSize
    });
  }
  /******************* Sorting model  ******************************/
  const [sortModel, setSortModel] = useState([
    {
      field: paginationModel.filters.sortBy,
      sort: paginationModel.filters.sortType,
    },
  ]);

  const handleSortingChange = (newSortModel) => {
    console.log("new sort model", newSortModel);
    if (newSortModel && newSortModel.length > 0) {
      setSortModel(newSortModel);
      setPaginationModel(prev => ({
        ...prev,
        filters: {
          ...prev.filters,
          sortBy: newSortModel[0].field,
          sortType: newSortModel[0].sort
        }
      }));
    }
  }

  const fetchCartList = async () => {
    setLoadingCart(true);
    const response = await CartService.getCartList({
      page: paginationModel.page,
      limit: paginationModel.pageSize,
      filters: {
        searchKey: paginationModel.filters.searchKey,
        sortBy: paginationModel.filters.sortBy,
        sortType: paginationModel.filters.sortType,
        filterOptions: paginationModel.filters.filterOptions || []
      }
    });
    console.log("fetch cart list response", response)
    if (response.success == '1') {
      if (response.data){
        setCartList(response.data.list);
        console.log("cart rows",response.data.list.length)
        setAllRowCount(response.data.totalItems);
      }else{
        setCartList([]);
        setAllRowCount(0);
      }
    }
    setLoadingCart(false);
  }
  useEffect(() => {
    fetchCartList();
  }, [paginationModel])

  const columns = [
    {
      field: 'customerDetails',
      headerName: 'Customer Details',
      headerAlign: 'center',
      flex: 2,
      minWidth: 150,
      filterable: false,
      sortable: false,
      renderCell: (params) => {
        return (
          <Box sx={{ display: 'flex', flexDirection: 'column', p: 1, width: '100%' }}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Typography sx={{ fontSize: '0.5rem', fontWeight: 500, minWidth: '25%' }}>CustomerId</Typography>
              <Typography sx={{ fontSize: '0.5rem', minWidth: '2%' }}>:</Typography>
              <Typography sx={{ cursor: 'pointer', fontSize: '0.5rem', color: '#1976d2' }} onClick={() => window.open(`/admin/customerProfile/${params.row?.customerId}`, '_blank')}>{params.row.customerId}</Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Typography sx={{ fontSize: '0.5rem', fontWeight: 500, minWidth: '25%' }}>Name</Typography>
              <Typography sx={{ fontSize: '0.5rem', minWidth: '2%' }}>:</Typography>
              <Typography sx={{ fontSize: '0.5rem' }}>{`${params.row?.customer?.profile?.firstName || ''} ${params.row?.customer?.profile?.middleName || ''} ${params.row?.customer?.profile?.lastName || ''}`}</Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Typography sx={{ fontSize: '0.5rem', fontWeight: 500, minWidth: '25%' }}>Contact</Typography>
              <Typography sx={{ fontSize: '0.5rem', minWidth: '2%' }}>:</Typography>
              <Typography sx={{ fontSize: '0.5rem' }}>{params.row?.customer?.mobileNumber}</Typography>
            </Box>
          </Box>
        )
      }
    },
    {
      field: 'exepertDetails',
      headerName: 'Cart Details',
      headerAlign: 'center',
      flex: 2,
      minWidth: 150,
      filterable: false,
      sortable: false,
      renderCell: (params) => {
        return (
          <Box sx={{ display: 'flex', flexDirection: 'column', p: 1, width: '100%' }}>
            
              {
                
                params.row.providerCarts && params.row.providerCarts.length > 0 &&
                params.row.providerCarts.map((p, index) => (
                  <Box sx={{ display: 'flex' }}>
                    <Typography sx={{ fontSize: '0.5rem', fontWeight: 500, minWidth: '25%' }}>Provider</Typography>
                    <Typography sx={{ fontSize: '0.5rem', minWidth: '2%' }}>:</Typography>
                    <Typography key={index} sx={{ cursor: 'pointer', fontSize: '0.5rem', color: '#1976d2' }} onClick={() => window.open(`/admin/expert-detail/${p.provider.id}`, '_blank')}>{p.provider.id}_{p.provider.UserProfile?.firstName} {p.provider.UserProfile?.lastName}</Typography>

                  </Box>
                ))
              }
            {/* <Box sx={{ display: 'flex' }}>
              <Typography sx={{ fontSize: '0.5rem', fontWeight: 500, minWidth: '25%' }}>Name</Typography>
              <Typography sx={{ fontSize: '0.5rem', minWidth: '2%' }}>:</Typography>
              <Typography sx={{ fontSize: '0.5rem' }}>{`${params.row?.User?.UserProfile?.firstName || ''} ${params.row?.User?.UserProfile?.middleName || ''} ${params.row?.User?.UserProfile?.lastName || ''}`}</Typography>
            </Box>
            <Box sx={{ display: 'flex' }}>
              <Typography sx={{ fontSize: '0.5rem', fontWeight: 500, minWidth: '25%' }}>Contact</Typography>
              <Typography sx={{ fontSize: '0.5rem', minWidth: '2%' }}>:</Typography>
              <Typography sx={{ fontSize: '0.5rem' }}>{params.row?.User?.mobileNumber}</Typography>
            </Box> */}
          </Box>
        )
      }
    },
    {
      field: 'createdAt',
      headerName: 'Created On',
      headerAlign: 'center',
      flex: 1,
      filterable: false,
      sortingOrder: ['asc', 'desc'],
      valueGetter: (params) => {
        return params.row.createdAt ? formatDateTime(params.row.createdAt) : '';
      },
      renderCell: (params) => {
        return (
          <Typography sx={{ fontSize: '0.55rem' }}>{params.row.createdAt ? formatDateTime(params.row.createdAt) : ''}</Typography>
        )
      }
    },
    {
      field: 'updatedAt',
      headerName: 'Updated On',
      headerAlign: 'center',
      flex: 1,
      filterable: false,
      sortingOrder: ['asc', 'desc'],
      valueGetter: (params) => {
        return params.row.lastUpdated ? formatDateTime(params.row.lastUpdated) : '';
      },
      renderCell: (params) => {
        return (
          <Typography sx={{ fontSize: '0.55rem' }}>{params.row.lastUpdated ? formatDateTime(params.row.lastUpdated) : ''}</Typography>
        )
      }
    },
    {
      field: "actions", headerName: "Action", sortable: false, filterable: false, flex: 1, renderCell: (params) => {

        return (
          <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Button sx={{ textTransform: 'none' }} size='small' variant='contained' onClick={() => handleViewDetails(params.row.providerCarts)} >
              View Details
            </Button>
          </Box>
        );
      },
      headerAlign: 'center',
    },
  ]

  const [viewDetails, setViewDetails] = useState({
    status: false,
    CustomerCart: []
  });
  const handleViewDetails = (CustomerCart) => {
    setViewDetails({
      status: true,
      CustomerCart:CustomerCart
    });
  }
  /************************  Advance Filter **************************** */


  const [clearMultiFilter, setClearMultiFilter] = useState(false);

  const filterableColumns = [
    {
      key: 'customerName',
      label: 'Customer Name',
      type: 'text'
    },
    // {
    //   key: 'customerId',
    //   label: 'CustomerId',
    //   type: 'number'
    // },
    {
      key: 'customerMobile',
      label: 'Custmer Mobile Number',
      type: 'number'
    },
    // {
    //   key: 'expertId',
    //   label: 'ExpertId',
    //   type: 'number'
    // },
    {
      key: 'expertMobile',
      label: 'Expert Mobile Number',
      type: 'number'
    },{
      key: 'expertName',
      label: 'Expert Name',
      type: 'text'
    }
  ];

  const handleApplyFilter = (filterData) => {
    // Process filter data
    console.log(filterData);
    setPaginationModel({
      ...paginationModel,
      page: 0, // Reset to first page when applying new filters
      filters: {
        ...paginationModel.filters,
        // Convert MultiColumnFilter options to a format your backend can understand
        filterOptions: filterData.filterOption.filter(filter => filter.fieldName && filter.value) // Remove empty filters
      }
    });
  }
  return (
    <>
      <Box sx={{ overflow: "auto" }}>
        {loadingCart && <Loading />}
        <Box sx={{ width: "100%", display: "table", tableLayout: "fixed", backgroundColor: "#fff", borderRadius: '.5rem' }}>
          <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center', px: '1%' }}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <MultiColumnFilter
                filterableColumns={filterableColumns}
                onApplyFilter={handleApplyFilter}
                externalClear={clearMultiFilter}
              />
              <ExportAll
                paginationModel={paginationModel} 
                // columns={columns} 
                // statusOptions={statusOptions} 
              />
            </Box>

            {/* <QuickSearchTool filterModel={filterModel} setFilterModel={setFilterModel} /> */}
          </Box>
          <DataGrid
            rows={cartList}
            columns={columns.map((col) => ({
              ...col,
              // flex: col.flex || 1, // Ensure columns resize dynamically
              minWidth: isSm && (col.minWidth || 100), // Set a minimum width to avoid overlap
            }))}
            getRowId={(row) => row.customerId}
            //checkboxSelection={true}
            rowCount={allRowCount}  // Use the length of the filtered list
            pageSizeOptions={[5, 10, 20, 50, 100]}
            paginationModel={paginationModel}
            paginationMode="server"
            onPaginationModelChange={handlePaginationChange}

            // filterModel={filterModel}

            sortingMode="server"
            sortModel={sortModel}
            onSortModelChange={handleSortingChange}
            disableMultiSort={true}

            loading={loadingCart}

            disableColumnMenu
            disableRowSelectionOnClick
            slots={{
              // toolbar: GridToolbar,                        
              loadingOverlay: Loading,
              noRowsOverlay: NoRowsLayout,
            }}
            autoHeight
            getRowHeight={() => 'auto'}
            sx={{
              '& .MuiDataGrid-cell': {
                border: 1,
                borderRight: 0,
                borderTop: 0,
                borderColor: 'lightgrey',
                display: 'flex',
                alignItems: 'center',
                // justifyContent: 'center',
              },
              '& .MuiDataGrid-columnHeaders': {
                borderBottom: '2px solid rgba(224, 224, 224, 1)',
                borderTop: '2px solid rgba(224, 224, 224, 1)',
                fontWeight: 600,
                fontSize: '0.75rem',
                p: 0,
                height: 'fit-content',
                minHeight: '0 !important',
                height: '2rem'
              },
              '& .MuiDataGrid-columnHeader': {
                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                '&:last-child': {
                  borderRight: 'none',
                },
              },
              '& .MuiDataGrid-columnHeaderTitle': {
                fontWeight: 600,
                color: '#3e3e3e'
              },
              '& .MuiDataGrid-row': {
                '&:last-child .MuiDataGrid-cell': {
                  borderBottom: '1px solid rgba(224, 224, 224, 1)',
                },
                '& .MuiDataGrid-cell:last-child': {
                  borderRight: 'none',
                },
              },
              '& .MuiDataGrid-columnSeparator': {
                display: 'none',
              },
            }}
          />
        </Box>
      </Box>
      {/* modal */}
      <Modal
        open={viewDetails.status}
        // onClose={() => setOpenServiceDropdown(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ overflow: "scroll" }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: { xs: '50%', sm: '50%' },
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            p: 0,
            width: { xs: "95%", sm: "65%" },
            minHeight: '30%',
            // maxHeight: '80vh',
          }}

          borderRadius={2}
        >
          <Box sx={{ borderBottom: '1px solid lightGray', display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: '1% 2%' }}>
            <Typography sx={{ fontWeight: 600, fontSize: '.9rem' }} >
              Cart Detail's
            </Typography>
            <IconButton
              size='small'
              onClick={() => setViewDetails({
                status: false,
                CustomerCart: []
              })}
              sx={{ p: 0 }}
              color='error'
            >
              <Close sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }} />
            </IconButton>
          </Box>
          <CartDetails CustomerCart={viewDetails.CustomerCart} />
        </Box>
      </Modal>
    </>
  )
}

export default AbandonedCartList